import HotelSearchControlsWrapper from './HotelSearchControlsWrapper';

export default HotelSearchControlsWrapper;
